import comp from "./CollapsibleAssessmentTools";
export default comp;
